export enum WorkflowStepFunctionDataTransformationComponentMode {
  PreDataTransformation = 'preDataTransformation',
  PostDataTransformation = 'postDataTransformation'
}
